import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";

// axios.defaults.withCredentials = true;

let baseURL;
if (process.env.NODE_ENV !== "production") {
  baseURL = "http://localhost:8080/api/drawform";
} else {
  baseURL = "https://zsrbactivity.zsnews.cn/api/drawform";
}

const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};

export default createStore({
  state: {
    showStatement: false,
    shoottime: "",
    statement: "",
    curtime: 0,
    countDown: 0,
    applyStarttime: 0,
    startTime: "",
    endTime: "",
    termId: 0,
    images: "",
    video: "",
    user: {}
  },
  mutations: {
    updateShowStatement(state, showStatement) {
      state.showStatement = showStatement;
    },
    updateUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    getZsplusJsBrigde({ commit }) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateJsBridgePackage", data.data);
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      console.log(commit);
      return new Promise((resolve) => {
        axios
          .post("https://zsplus-fastapi.zsnews.cn/api/activity/auth/by-plus", {
            // .post("https://zsrbactivity.zsnews.cn/api/common/zsplusauth", {
            session_token: info.sessionToken
            // head: info.head,
            // nickName: info.nickName,
            // phone: info.phone,
            // gender: info.gender
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                resolve(data);
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.message);
              } else {
                tip(data.message);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByWx({ commit }, code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatoath", {
            params: {
              code
            }
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储微信授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("wxInfo", JSON.stringify(data.data));
                sessionStorage.setItem("nickName", data.data.nickname);
                resolve();
              } else {
                tip(data.msg);
              }
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    submit({ state }, values) {
      console.log(state);
      console.log(values);
      return new Promise((resolve, reject) => {
        axios
          .post(baseURL + "/upload", values)
          .then((res) => {
            // Toast("1" + res.status)
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                resolve();
              } else {
                Toast.fail(data.msg);
              }
            } else {
              Toast.fail("网络错误，请重试");
              reject();
            }
          })
          .catch(function (error) {
            if (error.response) {
              // 请求已发出，但服务器响应的状态码不在 2xx 范围内
              alert(error.response.data);
              alert(error.response.status);
              alert(error.response.headers);
            } else if (error.request) {
              // 请求已发出，但没有收到响应
              // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
              // 而在node.js中是 http.ClientRequest 的实例
              alert(error.request);
            } else {
              // 发生了一些问题，导致了请求的发送失败
              alert("Error", error.message);
            }
            alert(error.config);
            reject();
          });
      });
    }
  },
  modules: {}
});
